module.exports = __webpack_public_path__ + "img/icon-check.607bd929.svg";